export const localhostUrl = 'http://localhost:3000';
export const localhostUrls = ['www.localhost', 'localhost'];

export const prodhostUrl = 'https://inviteyou.ca';
export const prodhostUrls = ['www.inviteyou.ca', 'inviteyou.ca'];
